<template>
  <button
    type="button"
    @click="refreshPage"
    class="p-2 text-slate-600 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-slate-100 dark:hover:bg-slate-800/70 rounded-xl transition-all duration-150 border border-transparent hover:border-slate-200/80 dark:hover:border-slate-800 cursor-pointer"
    title="Refresh System Data"
    aria-label="Refresh page"
  >
    <RefreshCw
      :class="{ 'animate-spin': isRefreshing }"
      class="w-4 h-4 sm:w-5 sm:h-5"
    />
  </button>
</template>

<script>
  import { RefreshCw } from "lucide-vue-next";

  export default {
    name: "RefreshButton",
    components: {
      RefreshCw,
    },
    data() {
      return {
        isRefreshing: false,
      };
    },
    methods: {
      refreshPage() {
        this.isRefreshing = true;
        setTimeout(() => {
          window.location.reload();
        }, 300);
      },
    },
  };
</script>

<style scoped>
  button:focus {
    outline: none;
  }
</style>
